export enum GeneralStatus {
    InSetup = 0,
    Active = 1,
    Inactive = 2,
    Deleted = 3
}